<template>
  <form @submit.prevent="submit" :class="$style.form">
    <dl :class="[$style.form__inputs, $style.inputs]">
      <div :class="$style.inputs__row">
        <dt :class="$style.inputs__name">メールアドレス</dt>
        <dd :class="$style.inputs__value">
          <DolphinTextInput
            v-model="email"
            :class="$style.inputs__input"
            :invalid="invalid"
            :disabled="isLoading"
            name="email"
          />
        </dd>
      </div>
      <div :class="$style.inputs__row">
        <dt :class="$style.inputs__name">パスワード</dt>
        <dd :class="$style.inputs__value">
          <DolphinPasswordInput
            v-model="password"
            :class="$style.inputs__input"
            type="password"
            :invalid="invalid"
            :disabled="isLoading"
            :forceValidate="false"
          />
        </dd>
      </div>
    </dl>
    <div :class="$style.form__action">
      <FlatButton
        type="submit"
        size="large"
        variant="primary"
        :disabled="isLoading || !isFilled"
      >
        {{ isLoading ? 'ログイン中…' : 'ログイン' }}
      </FlatButton>
    </div>
  </form>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import DolphinPasswordInput from '@/features/password/components/DolphinPasswordInput.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

type Data = {
  email: string
  password: string
}

export default defineComponent({
  name: 'LoginPageForm',
  components: {
    DolphinTextInput,
    DolphinPasswordInput,
    FlatButton,
  },
  props: {
    invalid: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit', 'change'],
  data(): Data {
    return {
      email: '',
      password: '',
    }
  },
  watch: {
    email(value) {
      if (this.invalid && value !== '') {
        this.$emit('change', 'email')
      }
    },
    password(value) {
      if (this.invalid && value !== '') {
        this.$emit('change', 'password')
      }
    },
  },
  computed: {
    isFilled(): boolean {
      return this.email.length > 0 && this.password.length > 0
    },
  },
  methods: {
    submit(): void {
      this.$emit('submit', { email: this.email, password: this.password })
    },
  },
})
</script>

<style lang="scss" module>
.form {
  position: relative;

  &__action {
    display: flex;
    align-items: center;
    justify-content: center;

    &:nth-child(n + 2) {
      margin-top: 32px;
    }
  }
}

.inputs {
  &__name {
    color: $color-text-and-object-high-emphasis;
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
  }

  &__row {
    &:nth-child(n + 2) {
      margin-top: 32px;
    }
  }

  &__value {
    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }

  &__input {
    width: 100%;
    font-size: 16px;
  }
}

.button {
  width: 108px;
  font-size: 14px;

  &--loading {
    width: 124px;
  }
}
</style>
